//
import ProductModel from "@/models/Warehouse/WhProduct"
import ProductStocksModel from "@/models/Warehouse/WhProductStocks"

/**
 * 
 */
const fetch = ({ wh_product_id }) => ProductModel.append("stocks").find( wh_product_id )

/**
 * 
 */
const stock = ( wh_warehouse_id ) => ( stock, warehouse ) => {
    return warehouse.wh_warehouse_id === wh_warehouse_id ? stock + warehouse.logical_stock : stock
}

/**
 * 
 */
const stock_new = ( wh_product_id ) => ( stock, warehouse ) => {
    console.log({ wh_product_id, warehouse })

    return warehouse.wh_product_id === wh_product_id ? warehouse.stock : stock
}

/**
 * 
 */
const stocks = ( wh_warehouse_id ) => ( stocks, branch_office ) =>{
    return branch_office.wh_warehouses.reduce( stock( wh_warehouse_id ), 0 ) + stocks
}

/**
 * { lambda_description }
 *
 * @param      {Object}  arg1     The argument 1
 * @param      {<type>}  arg1.id  The identifier
 * @return     {<type>}  { description_of_the_return_value }
 */
const mapId = ({ wh_product_id, id }) => wh_product_id || id

/**
 * 
 */
export default ({ productsKey, warehouseKey, valuekey }) => ( ctx ) => {

    //
    ctx.wait = true

    //
    /*console.log({
        productsKey,
        warehouseKey,
        valuekey,
    })*/

    //
    const wh_products       = ctx.value[ productsKey ] || []
        , wh_warehouse_id   = ctx.value[ warehouseKey ]
        , wh_products_keys  = wh_products.map(mapId)

    //
    const request_data = {
        wh_product_ids: wh_products_keys,
        wh_warehouse_id: wh_warehouse_id,
    }

    //
    if ( wh_products_keys.length > 0 && wh_warehouse_id > 0 ) {

        //
        let productStocks = new ProductStocksModel()

        //
        productStocks
            .attach(request_data)
            .then(res => {

                //
                ctx.value[ productsKey ].forEach( ( product, index ) => {
                    ctx.value[ productsKey ][ index ][ valuekey ] = res.data.reduce( stock_new( product.wh_product_id || product.id ) , 0)
                })
            })
            .finally(() => {

                //
                ctx.wait = false
            })       
    } else {

        //
        ctx.wait = false
    }
}
